import { createReducer } from 'typesafe-actions';
import { AnimationEntryExit } from '../../components/Overlays/types';
import { OverlaysState } from './types';
import { OverlayActions, showOverlay, hideOverlay, exitContentWithAnimation } from './actions';

const overlayReducer = createReducer<OverlaysState, OverlayActions>({ byIds: {} })
    .handleAction(showOverlay, (state, { payload }) => {
        if (!state.byIds[payload.id] || !state.byIds[payload.id].isActive || payload.options) {
            return {
                ...state,
                byIds: {
                    ...state.byIds,
                    [payload.id]: { id: payload.id, isActive: true, options: payload.options },
                },
            };
        }
        return state;
    })
    .handleAction(hideOverlay, (state, { payload }) => {
        if (state.byIds[payload.id] && state.byIds[payload.id].isActive) {
            return {
                ...state,
                byIds: { ...state.byIds, [payload.id]: { id: payload.id, isActive: false } },
            };
        }
        return state;
    })
    .handleAction(exitContentWithAnimation, (state, { payload }) => {
        return {
            ...state,
            byIds: {
                ...state.byIds,
                [payload.id]: { ...state.byIds[payload.id], contentAnimate: AnimationEntryExit.EXIT },
            },
        };
    });

export default overlayReducer;
